// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tasks-tree[data-v-3f666242]{display:flex;flex-direction:column;width:100%;background-color:#fff;padding:30px}", ""]);
// Exports
module.exports = exports;
